import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { ActiveMeters, Reading, Meters } from "../edp-consumptions.models";
import { DashboardService } from "@edp-services/dashboard.service";
import { RegisterTypeEnum } from "@edp-enums/register-type.enum";
import { Contract } from "@edp-components/edp-contract";
import moment from "moment";
import { IntegerValidator } from "@edp-validators/integer.validator";
import { SpecialCharacterValidator } from "@edp-validators/special-character";
import { CheckLastInserted } from "@edp-validators/last-inserted.validator";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "edp-widget-consumptions-gas",
    templateUrl: "./edp-widget-consumptions-gas.component.html",
})
export class EdpContractConsumptionsGasComponent implements OnInit {
    @Input() contract: Contract;
    @Input() set activeMeters(activeMeters: ActiveMeters) {
        if (activeMeters && activeMeters.meters.length) {
            this.consumptionsForm = this.formBuilder.group({
                typeLT: new FormControl(null, [Validators.required, Validators.min(0)]),
            });
            this.activeMetersGas = activeMeters;

            const meterGas = this.activeMetersGas.meters.find(m => m.RegisterType === RegisterTypeEnum[RegisterTypeEnum.LT]);
            this.meterGas = { ...meterGas };

            this.meterGas.OutsideConsumption = false;

            if (!!this.activeMetersGas.lastInserted) {
                this.setReadingsValidators();
            } else {
                this.consumptionsForm
                    .get("typeLT")
                    .setValidators([
                        Validators.required,
                        Validators.min(0),
                        Validators.maxLength(!!meterGas?.Predecimalplaces ? Number(meterGas.Predecimalplaces) : 8),
                        IntegerValidator,
                        SpecialCharacterValidator,
                        CheckLastInserted(this.activeMetersGas.lastInserted.LT, this.getMaxReadValue("LT")),
                    ]);
                this.consumptionsForm.updateValueAndValidity();
            }
        }
    }
    @Output() submitted: EventEmitter<any> = new EventEmitter();

    public activeMetersGas: ActiveMeters;
    public consumptionsForm: FormGroup;
    public showAlertMessage = false;
    public isSubmitted: boolean;
    public meterGas: Meters = null;
    public RegisterTypeEnum = RegisterTypeEnum;
    public noConsumptionData: boolean;
    public isTypeMeterError: boolean;

    constructor(private formBuilder: FormBuilder, public dashboardService: DashboardService) {}

    ngOnInit() {
        if (!this.contract.Ird_start || !this.contract.Ird_end) {
            this.noConsumptionData = true;
        }

        this.consumptionsForm?.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
            this.checkErrors();
        });
    }

    public getMaxReadValue = (type: string): string | null => {
        const getRegisterType = item => item.RegisterType === type;
        const maxRead = this.activeMetersGas.meters.filter(getRegisterType)[0].MaxRead;
        return maxRead;
    }

    public consumptionsFormChange(event: any) {
        this.meterGas.ReadingResult = event.target.value;
        this.meterGas.OutsideConsumption = false;
        this.showAlertMessage = false;

        if (this.meterGas.ReadingResult.length) {
            if (
                Number(this.meterGas.ReadingResult) > Number(this.meterGas.MaxRead) ||
                Number(this.meterGas.ReadingResult) < Number(this.meterGas.MinRead)
            ) {
                this.meterGas.OutsideConsumption = true;
                this.showAlertMessage = true;
            }
        }
    }

    public onSubmit() {
        this.isSubmitted = true;
        const readings: Reading[] = [];
        const extUi = this.contract.BasicComponent.filter(component => component.SupplyType === this.activeMetersGas.supplyType).map(
            x => x.DeliveryPoint
        )[0];

        readings.push(
            new Reading(
                this.meterGas.Brand,
                this.meterGas.Material,
                this.meterGas.Model,
                this.meterGas.Serialno,
                this.meterGas.Register,
                this.meterGas.RegisterType,
                this.meterGas.RegisterTypeStr,
                this.meterGas.ReadingResult,
                extUi
            )
        );

        const args: any = {
            contractId: this.contract.ContractId,
            SupplyType: !!this.activeMetersGas.supplyType ? this.activeMetersGas.supplyType : "G",
            ReadingsList: readings,
        };

        this.submitted.emit(args);
    }

    private setReadingsValidators() {
        const actualDate = moment().format("YYYY-MM-DD");
        const lastInserted = this.activeMetersGas.lastInserted;
        const lastValidReading = this.activeMetersGas.lastValidReading;

        const min = moment(actualDate).isSame(lastInserted.date)
            ? lastValidReading
                ? lastValidReading[RegisterTypeEnum[RegisterTypeEnum.LT]]
                : 0
            : lastInserted[RegisterTypeEnum[RegisterTypeEnum.LT]];

        this.consumptionsForm
            .get("typeLT")
            .setValidators([
                Validators.required,
                Validators.min(!!min ? min : 0),
                Validators.maxLength(!!Number(this.meterGas.Predecimalplaces) ? Number(this.meterGas.Predecimalplaces) : 8),
                IntegerValidator,
                SpecialCharacterValidator,
                CheckLastInserted(this.activeMetersGas.lastInserted.LT, this.getMaxReadValue("LT"))
            ]);
    }

    public checkErrors() {
        this.isTypeMeterError = this.consumptionsForm.get("typeLT").invalid && !this.consumptionsForm.get("typeLT").errors?.required;
    }
}
